var BlockView = require('views/block/base-block-view');
import SessionStorageService from 'services/web-storage-service/session-storage-service';
var LocaleService = require('services/locale-service');
var EnrollmentDataService = require('services/enrollment-data-service');
var utils = require('lib/utils');
var ef = require('ef/ef');

var TextView = BlockView.extend({
  className: 'items',
  initialize: function() {
    _.each(this.model.get('items'), function(item, idx) {
      if(item.custom_description) {
        var customization = ef.customizations.getByKeyAndSlug('text-content-customization', item.custom_description);
        if(customization) {
          item.custom = true;
          item.displayDescription = utils.renderMarkdown(customization.custom_text);
        }
      } else {
        if(ef.forge_mode) {
          item.forge_mode = true;
        }
        item.displayDescription = LocaleService.t(item.description);
      }
      item.itemname = 'item'+idx;
    });
    var items;
    if(this.model.get('session_key') && !this.model.get('initialized')) {
      let contentObject = SessionStorageService.getByDotString(this.model.get('session_key'));
      if(contentObject !== undefined) {
        let newItems;
        if(Array.isArray(contentObject)) {
          newItems = contentObject.map((text) => {
            return this.model.get('session_localization') ? {displayDescription: LocaleService.t(text)} : {displayDescription: text};
          });
        } else {
          newItems = this.model.get('session_localization') ? [{displayDescription: LocaleService.t(contentObject.toString())}] : [{displayDescription: contentObject.toString()}];
        }

        items = this.model.get('items');
        this.model.set('initialized', true);
        if(items) {
          this.model.set('items', items.concat(newItems));
        } else {
          this.model.set('items', newItems);
        }
      }
    }
    if(this.model.get('enrollment_key') && !this.model.get('initialized')) {
      let contentObject = EnrollmentDataService.getByDotString(this.model.get('enrollment_key'));
      if(contentObject !== undefined) {
        let newItems;
        if(Array.isArray(contentObject)) {
          newItems = contentObject.map((text) => {
            return this.model.get('enrollment_localization') ? {displayDescription: LocaleService.t(text)} : {displayDescription: text};
          });
        } else {
          newItems = this.model.get('enrollment_localization') ? [{displayDescription: LocaleService.t(contentObject.toString())}] : [{displayDescription: contentObject.toString()}];
        }

        items = this.model.get('items');
        this.model.set('initialized', true);
        if(items) {
          this.model.set('items', items.concat(newItems));
        } else {
          this.model.set('items', newItems);
        }
      }
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    var self = this;
    this.renderMultipleNestedBlocks('items');
    if(this.model.get('hover_class')) {
      this.$el.hover(function() {
        self.$el.addClass(self.model.get('hover_class'));
      }, function() {
        self.$el.removeClass(self.model.get('hover_class'));
      });
      this.$el.focus(function() {
        self.$el.addClass(self.model.get('hover_class'));
      });
      this.$el.blur(function() {
        self.$el.removeClass(self.model.get('hover_class'));
      });
    }
    this.$('.marked-down a').attr('target', '_blank');
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = TextView;
